"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Sparkles, Droplet, Search, Lock, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const maintenanceTips = [{
  icon: Lock,
  title: "Usklađenost sa zakonima",
  description: "Korisnici su obvezni koristiti platformu isključivo u zakonskim okvirima, poštujući sve primjenjive lokalne i međunarodne propise."
}, {
  icon: Search,
  title: "Točnost informacija",
  description: "Svi podaci koje unesete moraju biti istiniti i ažurni. Pružanje lažnih informacija može rezultirati ograničenjem pristupa vašem računu."
}, {
  icon: Sparkles,
  title: "Poštivanje sadržaja",
  description: "Intelektualno vlasništvo i autorska prava na platformi moraju se poštovati. Zabranjeno je neovlašteno kopiranje ili distribucija materijala."
}, {
  icon: Droplet,
  title: "Zabrana zlouporabe",
  description: "Strogo je zabranjeno korištenje sustava za širenje zlonamjernog softvera, uznemiravanje drugih korisnika ili bilo kakve ilegalne aktivnosti."
}];
export default function PreventativeMaintenance() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="258071" id="odgovornosti-korisnika" className="py-16 md:py-24 bg-background text-foreground">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          
          {}
          <div ref={leftRef} className={`flex flex-col items-start gap-6 transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <span className="text-sm font-bold tracking-wider text-muted-foreground uppercase font-default">
              Pravila i obveze korištenja
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default text-foreground leading-tight font-bold">
              Vaše odgovornosti kao korisnika naše platforme
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed font-default">
              Kako bismo osigurali sigurno i profesionalno okruženje za sve, definirali smo jasna pravila ponašanja. Vaša suradnja ključna je za održavanje integriteta naših usluga.
            </p>
            <Button asChild size="lg" className="mt-4 bg-primary text-primary-foreground hover:bg-primary/90 shadow-md rounded-lg">
              <Link to="/TermsOfUsePage">
                <CalendarCheck className="mr-2 size-5" />
                Pročitajte cijele uvjete
              </Link>
            </Button>
          </div>

          {}
          <div ref={rightRef} className={`flex flex-col gap-8 transition-all duration-700 delay-200 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {maintenanceTips.map((tip, i) => <div key={i} data-index={i} className="flex gap-4 md:gap-6">
                <div className="shrink-0 flex items-center justify-center size-12 rounded-lg bg-accent border border-border text-primary shadow-sm">
                  <tip.icon className="size-5" />
                </div>
                <div className="flex flex-col gap-1.5">
                  <h3 className="text-xl font-default font-semibold text-foreground">
                    {tip.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed font-default">
                    {tip.description}
                  </p>
                </div>
              </div>)}
          </div>

        </div>
      </div>
    </section>;
}